/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../notification/message/message.component.ngfactory';
import * as import2 from '../../notification/message/message.component';
import * as import3 from '../../notification/notification.service';
import * as import4 from 'ng2-translate/src/translate.pipe';
import * as import5 from 'ng2-translate/src/translate.service';
import * as import6 from '@angular/common';
import * as import7 from '../../buttons/link/link.component.ngfactory';
import * as import8 from '../../buttons/link/link.component';
import * as import9 from '../../inputs/form/field-group/field-group.component.ngfactory';
import * as import10 from '../../inputs/form/field-group/field-group.component';
import * as import11 from '@angular/forms';
import * as import12 from '../../html-utils/html.pipe';
import * as import13 from '@angular/platform-browser';
import * as import14 from '../../string-utils/possessive.pipe';
import * as import15 from '../../string-utils/currency.pipe';
import * as import16 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import17 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import18 from '../../orchestration/page';
import * as import19 from '../../orchestration/navigation.service';
import * as import20 from './customer-orders-page.component';
import * as import21 from '../../identity/member-sales-search.model';
import * as import22 from '../../identity/identity.model';
import * as import23 from '../../order/order.model';
import * as import24 from '../../orchestration/session.model';
import * as import25 from '../../ordering-context/ordering-context.model';
import * as import26 from '../../order/recent-order.service';
import * as import27 from '../../ui-elements/loading/loading.service';
import * as import28 from '@fedelta-pos/data-client/resource/search/search.model';
import * as import29 from '@fedelta-pos/data-client/resource/search/abstract-search.model';
const styles_CustomerOrdersPageComponent:any[] = ([] as any[]);
export const RenderType_CustomerOrdersPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CustomerOrdersPageComponent,
  data: {}
}
);
function View_CustomerOrdersPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_ContentMessageComponent_0,import1.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        2,
        4
      ]
    ],1,import2.ContentMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,4,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.INFO;
    const currVal_9:any = 'woa.message.orders.noOrders';
    ck(v,1,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_CustomerOrdersPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-title-number'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (((<any>v.parent).context.$implicit.placedOrder == null)? (null as any): (<any>v.parent).context.$implicit.placedOrder.receiptId);
    ck(v,1,0,currVal_0);
  });
}
function View_CustomerOrdersPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-details'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['table']),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform('woa.message.order.summary.tableNumber',ck(v,1,0,(<any>v.parent).context.$implicit.orderInitiation.tableNumber)));
    ck(v,0,0,currVal_0);
  });
}
function View_CustomerOrdersPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'div',[[
        'class',
        'order'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'order-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-title-type'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerOrdersPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerOrdersPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-details'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(2),
    import0.ɵppd(1),
    import0.ɵpod([
      'date',
      'time',
      'groupOrderName',
      'store',
      'address'
    ]
    ),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-details'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵpod(['total']),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'order-actions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.viewOrderDetails(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import7.View_LinkComponent_0,import7.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import8.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = ((v.context.$implicit.placedOrder == null)? (null as any): v.context.$implicit.placedOrder.receiptId);
    ck(v,9,0,currVal_1);
    const currVal_2:any = (v.context.$implicit.orderInitiation.orderTypeEnum === co.OrderType.ORDER_AT_TABLE);
    ck(v,13,0,currVal_2);
    const currVal_5:any = 'woa.button.order.viewOrder';
    ck(v,30,0,currVal_5);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform(co.getOrderDescription(v.context.$implicit)));
    ck(v,5,0,currVal_0);
    const currVal_3:any = import0.ɵunv(v,15,0,ck(v,20,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,15,0,import0.ɵnov(v,19).transform(co.getOrderMessage(v.context.$implicit,v.context.$implicit.initiatedOrder.store),ck(v,18,0,import0.ɵunv(v,15,0,ck(v,16,0,import0.ɵnov((<any>(<any>v.parent).parent),1),v.context.$implicit.placedOrder.placedDateTime,'medium')),co.getOrderTime(v.context.$implicit),import0.ɵunv(v,15,0,ck(v,17,0,import0.ɵnov((<any>(<any>v.parent).parent),2),v.context.$implicit.orderInitiation.transferTargetName)),v.context.$implicit.initiatedOrder.store.collectiveStoreName,v.context.$implicit.orderPlacement.address.formattedAddress)))));
    ck(v,15,0,currVal_3);
    const currVal_4:any = import0.ɵunv(v,22,0,import0.ɵnov(v,25).transform('woa.message.order.summary.orderTotal',ck(v,24,0,import0.ɵunv(v,22,0,ck(v,23,0,import0.ɵnov((<any>(<any>v.parent).parent),3),v.context.$implicit.initiatedOrder.orderTotal)))));
    ck(v,22,0,currVal_4);
  });
}
function View_CustomerOrdersPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-field-group',([] as any[]),(null as any),(null as any),(null as any),import9.View_FieldGroupComponent_0,import9.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import10.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import11.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import10.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_CustomerOrdersPageComponent_3)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.identityModel.isGuestUser? 'woa.heading.orders.recentOrders': 'woa.heading.orders.currentOrders');
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.recentOrders;
    ck(v,5,0,currVal_1);
  },(null as any));
}
function View_CustomerOrdersPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-title subtitle'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      ' ',
      '\n            '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.label.sale-summary.saleReceiptNo'));
    const currVal_1:any = (<any>v.parent).context.$implicit.saleReceiptNo;
    ck(v,1,0,currVal_0,currVal_1);
  });
}
function View_CustomerOrdersPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-details'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['points']),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform('woa.message.order.summary.pointsEarned',ck(v,1,0,(<any>v.parent).context.$implicit.pointsAccrued)));
    ck(v,0,0,currVal_0);
  });
}
function View_CustomerOrdersPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.requestInvoice((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import7.View_LinkComponent_0,import7.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import8.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.sale-summary.sendInvoice';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_CustomerOrdersPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'order'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerOrdersPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-details'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(2),
    import0.ɵpod([
      'date',
      'store'
    ]
    ),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-details'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵpod(['total']),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerOrdersPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'order-actions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.viewReceipt(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import7.View_LinkComponent_0,import7.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import8.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerOrdersPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = v.context.$implicit.saleReceiptNo;
    ck(v,7,0,currVal_1);
    const currVal_4:any = v.context.$implicit.pointsAccrued;
    ck(v,20,0,currVal_4);
    const currVal_5:any = 'woa.button.sale-summary.viewReceipt';
    ck(v,25,0,currVal_5);
    const currVal_6:any = (v.context.$implicit.customerRefNo && co.sessionModel.currentApp.orderReceivedEmail.id);
    ck(v,28,0,currVal_6);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.getSaleDescription(v.context.$implicit)));
    ck(v,3,0,currVal_0);
    const currVal_2:any = import0.ɵunv(v,9,0,import0.ɵnov(v,12).transform('woa.message.order.summary.orderPlaced',ck(v,11,0,import0.ɵunv(v,9,0,ck(v,10,0,import0.ɵnov((<any>(<any>v.parent).parent),1),v.context.$implicit.saleDate,'medium')),v.context.$implicit.outletName)));
    ck(v,9,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,14,0,import0.ɵnov(v,17).transform('woa.message.order.summary.orderTotal',ck(v,16,0,import0.ɵunv(v,14,0,ck(v,15,0,import0.ɵnov((<any>(<any>v.parent).parent),3),v.context.$implicit.saleTotal)))));
    ck(v,14,0,currVal_3);
  });
}
function View_CustomerOrdersPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-field-group',([] as any[]),(null as any),(null as any),(null as any),import9.View_FieldGroupComponent_0,import9.RenderType_FieldGroupComponent)),
      import0.ɵdid(49152,(null as any),0,import10.FieldGroupComponent,([] as any[]),{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵprd(5120,(null as any),import11.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import10.FieldGroupComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_CustomerOrdersPageComponent_7)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'woa.heading.orders.orderHistory';
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.memberSalesSearchModel.data;
    ck(v,5,0,currVal_1);
  },(null as any));
}
export function View_CustomerOrdersPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import12.HtmlPipe,[import13.DomSanitizer]),
    import0.ɵpid(0,import6.DatePipe,[import0.LOCALE_ID]),
    import0.ɵpid(0,import14.PossessivePipe,([] as any[])),
    import0.ɵpid(0,import15.CurrencyPipe,([] as any[])),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalPageLayoutComponent_0,import16.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import17.ModalPageLayoutComponent,[
      import18.Page,
      import19.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      subtitle: [
        1,
        'subtitle'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
    import0.ɵpod(['count']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import18.PageLayout,(null as any),[import17.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),3,1,(null as any),View_CustomerOrdersPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_CustomerOrdersPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_CustomerOrdersPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import20.CustomerOrdersPageComponent = v.component;
    const currVal_0:any = 'woa.heading.orders.title';
    const currVal_1:any = ((co.saleCount === 0)? 'woa.label.orders.orderCount.zero': ((co.saleCount === 1)? 'woa.label.orders.orderCount.singular': 'woa.label.orders.orderCount.plural'));
    const currVal_2:any = ck(v,9,0,co.saleCount);
    ck(v,6,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = (co.saleCount < 1);
    ck(v,13,0,currVal_3);
    const currVal_4:any = co.recentOrders.length;
    ck(v,16,0,currVal_4);
    const currVal_5:any = co.memberSalesSearchModel.data.length;
    ck(v,19,0,currVal_5);
  },(null as any));
}
function View_CustomerOrdersPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'woa-customer-orders-page',([] as any[]),(null as any),(null as any),(null as any),View_CustomerOrdersPageComponent_0,RenderType_CustomerOrdersPageComponent)),
    import0.ɵprd(512,(null as any),import21.MemberSalesSearchModel,import21.MemberSalesSearchModel,[import0.Injector]),
    import0.ɵdid(114688,(null as any),0,import20.CustomerOrdersPageComponent,[
      import21.MemberSalesSearchModel,
      import22.IdentityModel,
      import23.OrderModel,
      import24.SessionModel,
      import25.OrderingContextModel,
      import26.RecentOrderService,
      import19.NavigationService,
      import27.LoadingService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import18.Page,(null as any),[import20.CustomerOrdersPageComponent]),
    import0.ɵprd(6144,(null as any),import28.SearchModel,(null as any),[import21.MemberSalesSearchModel]),
    import0.ɵprd(6144,(null as any),import29.AbstractSearchModel,(null as any),[import21.MemberSalesSearchModel])
  ]
  ,(ck,v) => {
    ck(v,2,0);
  },(null as any));
}
export const CustomerOrdersPageComponentNgFactory:import0.ComponentFactory<import20.CustomerOrdersPageComponent> = import0.ɵccf('woa-customer-orders-page',import20.CustomerOrdersPageComponent,View_CustomerOrdersPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/customer-info/customer-orders-page/customer-orders-page.component.ngfactory.ts